import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/ItemPricelist/ItemPricelistAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesReportItemPricelistActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/ItemPricelist/ItemPricelist")
	}

	render() {
		return (
			<Activity 
				name="SalesReportItemPricelist"
				RenderedComponent={this.RenderedComponent}
				context="SalesReportItemPricelist"
				action="SalesReportItemPricelist"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesReportItemPricelistActivity)
